function formatToBrazilianDate(dateString) {
  return dateString.split("-").reverse().join("/");
}

export default {
  async carregarCliente(context, payload) {
    const codigoCliente = payload.codigo;
    const senhaCliente = payload.senha;
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];
    var number = codigoCliente.replace(/\D/g, "");
    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/Cliente/Get/0?token=${enderecoLoja}&CNPJ_CPF=${number}
      `
    );

    const responseData = await response.json();

    if (responseData.length >= 1) {
      for (const key in responseData) {
        if (
          responseData[key].endereco.length === 0 &&
          responseData[key].senha == senhaCliente
        ) {
          const dadosCliente = {
            codigo: responseData[key].codigo,
            aprovado: responseData[key].aprovado,
            nome: responseData[key].nome,
            razao: responseData[key].razao,
            cnpj: responseData[key].cnpj,
            rg: "",
            cpf: responseData[key].cpf,
            senha: responseData[key].senha,
            telefone: responseData[key].telefone,
            celular: responseData[key].celular,
            contato: responseData[key].contato,
            IE: responseData[key].IE,
            email: responseData[key].email,
            site: "",
            observacao: "",
            foto: "",
            codigo_mobile: 1,
          };
          context.commit("carregarDadosCliente", dadosCliente);
          context.commit("usuarioLogado");
        } else if (
          responseData[key].endereco.length > 0 &&
          responseData[key].senha == senhaCliente
        ) {
          for (const yek in responseData[key].endereco) {
            const dadosCliente = {
              codigo: responseData[key].codigo,
              aprovado: responseData[key].aprovado,
              nome: responseData[key].nome,
              razao: responseData[key].razao,
              cnpj: responseData[key].cnpj,
              rg: "",
              cpf: responseData[key].cpf,
              senha: responseData[key].senha,
              telefone: responseData[key].telefone,
              celular: responseData[key].celular,
              contato: responseData[key].contato,
              IE: responseData[key].IE,
              email: responseData[key].email,
              site: "",
              observacao: "",
              foto: "",
              codigo_mobile: 1,
              endereco: [
                {
                  codigo: responseData[key].endereco[yek].codigo,
                  cidade: responseData[key].endereco[yek].cidade,
                  logradouro: responseData[key].endereco[yek].logradouro,
                  bairro: responseData[key].endereco[yek].bairro,
                  numero: responseData[key].endereco[yek].numero,
                  complemento: responseData[key].endereco[yek].complemento,
                  cep: responseData[key].endereco[yek].cep,
                  uf: responseData[key].endereco[yek].uf,
                },
              ],
            };
            context.commit("carregarDadosCliente", dadosCliente);
            context.commit("usuarioLogado");
          }
        } else {
          window.alert("Senha errada! Tente novamente.");
          const dadosCliente = null;
          context.commit("carregarDadosCliente", dadosCliente);
        }
      }
    } else {
      window.alert("Usuário não encontrado, fazer novo cadastro?");
      const dadosCliente = null;
      context.commit("carregarDadosCliente", dadosCliente);
    }
  },

  resetCliente(context) {
    context.commit("resetCliente");
    context.commit("usuarioDeslogado");
  },

  async carregarMeusPedidos(context, payload) {
    context.commit("carregamentoIniciado");
    const codigoCliente = payload.codigo;
    const senhaCliente = payload.senha;
    const cnpjEmpresa = payload.cnpj;
    const dataInicio = payload.dataInicio + " 00:00:00";
    const dataFim = payload.dataFim + " 23:59:59";
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];

    const response =
      await fetch(`https://apiciriuserp.com.br:2083/api/Cliente/Get/0?token=${enderecoLoja}&CNPJ_CPF=${codigoCliente}
    `);

    const responseData = await response.json();

    try {
      const codigo = responseData[0].codigo;

      const response2 = await fetch(
        `https://apiciriuserp.com.br:2083/api/Venda/Get/0?token=${enderecoLoja}&cnpj=${cnpjEmpresa}&de=${dataInicio}&ate=${dataFim}&cliente=${codigo}
        `
      );

      const response2Data = await response2.json();
      const meusPedidos = [];

      if (response2Data.length >= 1 && senhaCliente == responseData[0].senha) {
        for (const key in response2Data) {
          const meuPedido = {
            origem: response2Data[key].origem,
            codigoVenda: response2Data[key].codigo,
            empresa: response2Data[key].empresa,
            dataInclusao: formatToBrazilianDate(
              response2Data[key].data_inclusao.substr(0, 10)
            ),

            previsao: formatToBrazilianDate(
              response2Data[key].previsao_entrega.substr(0, 10)
            ),
            valorTotal: response2Data[key].valorLiquido,
            notafiscal: response2Data[key].notafiscal,
            ChaveEletronicaNFeSaida: response2Data[key].ChaveEletronicaNFeSaida,
            descricao: response2Data[key].descricao_status,
            Rastreamento: response2Data[key].rastreamento,
            itens: [],
          };
          meusPedidos.push(meuPedido);
        }
        for (const key in response2Data) {
          for (const yek in response2Data[key].itens) {
            const meuPedidoItens = {
              ref: response2Data[key].itens[yek].ref_produto,
              nomeproduto: response2Data[key].itens[yek].nome_produto,
              descSku: response2Data[key].itens[yek].descricao_sku,
              preco: response2Data[key].itens[yek].preco,
              quantidade: response2Data[key].itens[yek].quantidade,
              precoTotal: response2Data[key].itens[yek].precototal,
              url: response2Data[key].itens[yek].URL,
            };
            meusPedidos[key].itens.push(meuPedidoItens);
          }
        }
        context.commit("carregarMeusPedidos", meusPedidos);
        context.commit("carregamentoConcluido");
      } else {
        context.commit("carregarMeusPedidos", null);
        context.commit("carregamentoConcluido");
      }
    } catch (error) {
      console.log(error);
    }
  },

  async recuperarSenha(context, payload) {
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];
    const email = payload.email;
    const response = await fetch(
      `https://apiciriuserp.com.br:2083/api/RecuperarSenha/Post?pToken=${enderecoLoja}&pEmail=${email}
      `,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );

    const responseData = await response.json();
    context.commit("carregarRecuperarSenha", responseData);
  },
};
